import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { FormError, HelpText } from '@Forms/fields.jsx';
import { fromLocalDate, toLocalDate } from '@Forms/utils.js';

const DateField = (props) => {
  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-input ` +
        (props.error ? 'sb-form-item-error' : '')
      }
    >
      <label htmlFor={props.field.name}>{props.label}</label>
      <div className="sb-form-item-content">
        <DatePicker
          placeholderText="Select date"
          aria-invalid={props.error ? 'true' : 'false'}
          selected={toLocalDate(props.value)}
          isClearable={props.isClearable}
          onChange={(day) => {
            return props.field.onChange(fromLocalDate(day));
          }}
        />
        {props.helpText && <HelpText message={props.helpText} />}
        {props.error && <FormError message={props.error.message} />}
      </div>
    </div>
  );
};

export default DateField;
